import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=45522bac&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45522bac')) {
      api.createRecord('45522bac', component.options)
    } else {
      api.reload('45522bac', component.options)
    }
    module.hot.accept("./MainHeader.vue?vue&type=template&id=45522bac&", function () {
      api.rerender('45522bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Core/Header/MainHeader.vue"
export default component.exports